import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { APIRequest } from 'api-provider';
import { SelectField } from 'components/forms';
import { SimpleForm } from 'components/forms';
import { ModalField } from './ModalField';
import { getUsers } from 'containers/Dashboard/sections/Sales/Sales/_shared/resources';
import __ from 'utils/i18n';

export const UserField = ({
  applicatedFields,
  setApplicatedFields,
}) => {
  const token = useSelector((state) => state.api.token);
  const { subsidiaryId: userSubsidiaryId, isOwner } = useSelector((state) => state.login.user);
  const userId = applicatedFields?.userId;
  const [selectedUserId, setSelectedUserId] = useState(userId || null);
  const translationKey = 'dashboard.components.filterForm.fields.user';
  const title = __(translationKey + '.title');
  const description = __(translationKey + '.description');

  useEffect(() => {
    setSelectedUserId(userId || null);
  }, [userId]);

  const applyFilters = () => {
    setApplicatedFields({
      ...applicatedFields,
      userId: selectedUserId,
    });
  };

  const cleanFilters = () => {
    setSelectedUserId(null);
    setApplicatedFields({
      ...applicatedFields,
      userId: null,
    });
  };

  return (
    <ModalField
      field="user"
      title={title}
      description={description}
      fieldIsActive={userId}
      applyFilters={applyFilters}
      cleanFilters={cleanFilters}
    >
      <div className="filters-user-field">
        <APIRequest resource={getUsers(token)} fetch>
          {(request) => {
            const options = [
              {
                value: null,
                label: __(translationKey + '.allUsers'),
              },
            ];
            if (request && request.response) {
              const filteredUsers = request.response.filter((user) => {
                if (isOwner) {
                  return true;
                }
                return user.subsidiaryId === userSubsidiaryId;
              });
              filteredUsers.forEach((user) => {
                options.push(user);
              });
            }
            return (
              <SimpleForm
                values={{ userId: selectedUserId }}
                onChange={({ values }) => setSelectedUserId(values.userId)}
              >
                <SelectField
                  field="userId"
                  options={options}
                  placeholder={__(translationKey + '.placeholder')}
                />
              </SimpleForm>
            );
          }}
        </APIRequest>
      </div>
    </ModalField>
  );
};

